import { captureException } from '@sentry/react';
import {
  PaymentElement,
  useElements,
  useStripe,
} from '@stripe/react-stripe-js';
import { useEffect } from 'react';

import { useStripeContext } from '@frontend/utils';

export interface StripeElementsProps {
  onChange: (stripeSelected: boolean) => void;
}

export const StripeElements = (props: StripeElementsProps) => {
  const stripe = useStripe();
  const elements = useElements();
  const {
    setStripe,
    setElements,
    paymentElementOptions,
    updateElementsInputValidity,
    elementsInputValid,
  } = useStripeContext();

  useEffect(() => {
    if (stripe) {
      setStripe(stripe);
    }

    if (elements) {
      setElements(elements);
    }
  }, [stripe, elements]);

  return (
    <PaymentElement
      options={paymentElementOptions}
      onChange={(e) => {
        if (e.complete !== elementsInputValid) {
          updateElementsInputValidity(e.complete);
        }
        props.onChange(!e.collapsed);
      }}
      onLoadError={(e) => {
        captureException(`Stripe Elements onLoad error: ${e.error.message}`, {
          level: 'warning',
        });
      }}
    />
  );
};
